import React from 'react';
import { PREFERENCE_TOGGLES, MUSIC_OPTIONS, prefsSummary, prefsFromProfile } from '../lib/cabin';
import TempDial from './TempDial';

// A choice of two or three: a pill with a sliding thumb.
function Choice({ label, options, value, onChange, testid }) {
  const i = Math.max(0, options.indexOf(value));
  const n = options.length;
  return (
    <div data-testid={testid}>
      <p className="text-xs tracking-[0.18em] uppercase text-gray-300 mb-2.5">{label}</p>
      <div className="relative grid rounded-full border border-white/15 bg-white/[0.03] p-1" style={{ gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))` }} role="radiogroup" aria-label={label}>
        <span aria-hidden="true" className="absolute top-1 bottom-1 rounded-full bg-white/[0.12] border border-white/25 transition-transform duration-300 ease-out"
          style={{ left: 4, width: `calc((100% - 8px) / ${n})`, transform: `translateX(${i * 100}%)` }} />
        {options.map((o) => (
          <button type="button" role="radio" aria-checked={value === o} key={o} onClick={() => onChange(o)} data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z]+/g, '-').replace(/-$/, '')}`}
            className={`relative z-10 min-h-[44px] px-1 rounded-full text-[15px] leading-tight transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/60 ${value === o ? 'text-white' : 'text-gray-300 hover:text-white'}`}>{o}</button>
        ))}
      </div>
    </div>
  );
}

export default function PreferencesCard({ prefs, setPrefs }) {
  const p = prefsFromProfile(prefs);
  const set = (k) => (v) => setPrefs((cur) => ({ ...cur, [k]: v }));
  return (
    <div data-testid="preferences" className="rounded-3xl border border-white/15 bg-white/[0.03] p-6 sm:p-7">
      <TempDial value={p.cabin_temp_f} onChange={(t) => setPrefs((cur) => ({ ...cur, cabin_temp_f: t }))} />
      <div className="h-px my-7 bg-white/10" aria-hidden="true" />
      <div className="space-y-6">
        {PREFERENCE_TOGGLES.map((g) => <Choice key={g.key} testid={`pref-${g.key}`} label={g.label} options={g.options} value={p[g.key]} onChange={set(g.key)} />)}
        <Choice testid="pref-music" label="Music" options={MUSIC_OPTIONS} value={p.music} onChange={set('music')} />
        {p.music === 'My audio' && <p className="text-sm text-gray-300 -mt-2" data-testid="my-audio-note">You connect your own phone in the car.</p>}
      </div>
      <p className="text-sm text-gray-300 mt-6" data-testid="prefs-summary">{prefsSummary(prefs)}</p>
      <p className="text-sm text-gray-400 mt-1">Your preferences are saved to your profile for future trips.</p>
    </div>
  );
}
